import { NavLink, useNavigate } from 'react-router-dom';
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { Button } from '../Button/Button';
import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';

const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuContent = DropdownMenuPrimitive.Content;
const DropdownMenuItem = DropdownMenuPrimitive.Item;
const DropdownMenuSeparator = DropdownMenuPrimitive.Separator;

const ProfileDropDown = () => {
    const navigate = useNavigate()
    const handleLogout = () => {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
    }
    return (
        <div className="flex items-center gap-4">
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    
                    className="rounded-full transition-colors  duration-300 pt-3 rounded-full bg-gray-100 dark:bg-gray-800 text-foreground dark:text-gray-100 dark:hover:text-gray-100"
                >
                    <Avatar className="h-8 w-8">
                        <AvatarImage src="/placeholder-user.jpg" />
                        <AvatarFallback>Admin</AvatarFallback>
                    </Avatar>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                sideOffset="1"
                align="end"
                className="z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md transition-colors duration-300 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100"
            >
                {/* <div className="flex items-center gap-2 p-2">
                    <Avatar className="h-8 w-8">
                        <AvatarImage src="/placeholder-user.jpg" />
                        <AvatarFallback>JD</AvatarFallback>
                    </Avatar>
                    <div className="grid gap-0.5 leading-none">
                        <div className="font-semibold">John Doe</div>
                        <div className="text-sm text-muted-foreground dark:text-gray-400">
                            john@example.com
                        </div>
                    </div>
                </div> */}
                {/* <DropdownMenuSeparator className="bg-gray-200 dark:bg-gray-700 -mx-1 my-1 h-px" /> */}
                {/* <DropdownMenuItem inset="4" className="relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:text-gray-900 dark:hover:text-white text-gray-800 dark:text-gray-100 pl-8">
                    <NavLink to="/profile">
                        <span>Profile</span>
                    </NavLink>
                </DropdownMenuItem> */}
                {/* <DropdownMenuItem className="relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:text-gray-900 dark:hover:text-white text-gray-800 dark:text-gray-100 pl-8">
                    <NavLink to="/settings">
                        <span>Settings</span>
                    </NavLink>
                </DropdownMenuItem> */}
                {/* <DropdownMenuSeparator className="bg-gray-200 dark:bg-gray-700 -mx-1 my-1 h-px" /> */}
                <DropdownMenuItem
                    onClick={handleLogout}
                    className="relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:text-gray-900 dark:hover:text-white text-gray-800 dark:text-gray-100 pl-8"
                >
                    <span>Sign out</span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
        </div>
    )
}

export default ProfileDropDown